import React, {Fragment, useCallback, useState, useRef} from "react";
import Input from "../Input";
import {useIntl, FormattedMessage} from "react-intl";
import sharedApiRequest from "@services/apiRequest";
import {CancelToken} from "axios";
import {PasswordErrors} from "./PasswordErrors";
import _ from "lodash";

const UpdatePassword = ({
  setPassword,
  setConfirmPassword,
  password,
  confirmPassword,
  checkUserOldPasswords,
}) => {

  const intl = useIntl();
  const [confirmError, setConfirmError] = useState("");
  const [passwordError, setPasswordError] = useState([]);
  const [showPassword, setShowPassword] = useState(false);

  const lastQuery = useRef();

  const handlePassword = useCallback(async (value) => {
    if (lastQuery.current) {
      lastQuery.current();
    }

    try {
      const errors = await sharedApiRequest.post("/users/password/check", value, {
        publicRequest: !checkUserOldPasswords,
        cancelToken: new CancelToken(function executor(c) {
          lastQuery.current = c;
        }),
        headers: {"Content-Type": "application/json"},
      });
      lastQuery.current = null;
      if (errors?.length > 0) {
        setPasswordError(() => errors);
        return false;
      } else {
        setPasswordError(() => []);
      }
    } catch (e) {
      console.log(e)
      if (lastQuery.current && e.message === "canceled") {
        return;
      }
    }
    return true;
    // eslint-disable-next-line
  }, []);

  const handleConfirmPassword = useCallback(
    (value) => {
      if (value !== password) {
        setConfirmError(intl.formatMessage({id: "passwords_not_matching"}));
        return false;
      }
      setConfirmError();
      return true;
    },
    [password, intl]
  );

  return (
    <Fragment>
      <div>
        <Input
          value={password}
          onInput={(e) => {
            _.debounce(() => handlePassword(e.target.value), 100)();
            setPassword(e.target.value);
          }}
          label={intl.formatMessage({
            id: "new_password", defaultMessage: "Nuova password"
          })}
          type={showPassword ? "text" : "password"}
          required
          data-cy="new-password"
          autoComplete="off"
          showErrorDialog={false}
        />
      </div>
      <PasswordErrors errors={passwordError}/>
      <div className="mt-4">
        <Input
          value={confirmPassword}
          onChange={(e) => {
            setConfirmPassword(e.target.value);
          }}
          validation={handleConfirmPassword}
          label={intl.formatMessage({ id: "confirm_password" })}
          type={showPassword ? "text" : "password"}
          errorMessage={confirmError}
          required
          data-cy="confirm-password"
          autoComplete="off"
        />
      </div>
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center">
          <input
            id="show-passwd"
            name="show-passwd"
            type="checkbox"
            className="h-4 w-4 text-am-600 focus:ring-am-500 border-gray-300 rounded"
            onChange={(e) => {
              setShowPassword(e.target.checked);
            }}
          />
          <label
            htmlFor="show-passwd"
            className="ml-2 block text-sm text-gray-900"
          >
            <FormattedMessage id="show_password"/>
          </label>
        </div>
      </div>
    </Fragment>
  );
};

export default UpdatePassword;
